import { render, staticRenderFns } from "./message-status-icon.vue?vue&type=template&id=92ca4e20&"
import script from "./message-status-icon.vue?vue&type=script&lang=js&"
export * from "./message-status-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports